<template>
  <div class="Page">
    <section>
      <div class="banner">
        <h1 class="PageTitle">Fiches techniques</h1>
      </div>
      <div class="orangeStripe"></div>
    </section>
    <section class="fichesSection">
      <v-row class="grid-pad">
        <v-col cols="12">
          <h2 class="sectionTitle">Fiches de sécurité</h2>
        </v-col>
        <v-col cols="12">
          <ul class="fichesList">
            <li v-for="fiche in fiches" :key="fiche">
              <a :href="'/ressources/fiches/' + fiche" target="_blank">{{ fiche }}</a>
            </li>
          </ul>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<style scoped>
  .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/parts/DptPieces.jpg'); background-position: center top; background-repeat: no-repeat; background-size: cover; overflow: hidden; }
  .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; z-index: 100; }
  .fichesSection { padding: 50px 0; }
  .sectionTitle { color: rgb(var(--secondary)); text-transform: uppercase; font-family: TxtOffBDI; margin-bottom: 30px; }
  .fichesList { list-style: none; padding: 0; }
  .fichesList li { padding: 8px 0; border-bottom: 1px solid rgb(var(--ligthGray)); }
  .fichesList li a { font-family: TxtOffRe; font-size: 18px; color: rgb(var(--dark)); text-decoration: none; }
  .fichesList li a:hover { color: rgb(var(--primary)); }
  @media handheld, only screen and (max-width: 960px) {
    h1 { font-size: 18px; }
    .fichesList li a { font-size: 15px; }
  }
</style>

<script>
export default {
  name: 'fiches',
  data: () => ({
    fiches: []
  }),
  async mounted() {
    try {
      const response = await fetch('/ressources/json/fiches.json');
      if (!response.ok) throw new Error('Failed to fetch');
      this.fiches = await response.json();
    } catch (error) {
      console.error('Error loading fiches.json:', error);
    }
  }
}
</script>
